import { Banner } from '@loadsmart/miranda-react'

import analytics from 'legacy/utils/analytics'

type SpotQuoteListRefreshBannerProps = {
  onRefreshList: () => void
}

export function SpotQuoteListRefreshBanner({ onRefreshList }: SpotQuoteListRefreshBannerProps) {
  function handleRefresh() {
    onRefreshList()
    analytics.track('Loadboard / Spot Quotes / Error / Reload')
  }

  return (
    <Banner variant="warning">
      <Banner.Title>Failed to get spot quotes. Please reload to try again.</Banner.Title>
      <Banner.Actions>
        <Banner.ActionPrimary onClick={handleRefresh}>Reload</Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  )
}
